import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const StyledDisclaimer = styled('div')((props) => {
    const {
        theme: { spacing }
    } = props;
    return css`
        padding: ${spacing['16px']} 0;
    `;
});
